<template>
  <div class="balance-page">
    <div class="disclaimer-background">
      <div class="disclaimer-content">
        <div class="icon"><img :src="require('@/assets/icons/notice-gray.svg')"/></div>
        <div class="text">      בחלק מהמקרים, הסכומים שמופיעים כאן לא זהים לאלה באתרי הבנק וחברות האשראי.
          <span class="bold"> המערכת שלנו מחשבת רק תנועות שאושרו, ולא כוללת תנועות לא סופיות.</span></div>
      </div>
    </div>
    <div class="balance-page-content">
      <div v-if="hasBalance">
        <page-section-header title-text="יתרת העו״ש" color="green" icon="v-outline"/>
        <div class="cards-container">
          <base-balance-page-card v-for="data of balances" :key="data.account"
                                  :amount="data.balance"
                                  :account="data.account"
                                  :source="data.source"
                                  :last-updated="data.lastUpdated"
                                  :credentials-name="data.credentialsName"/>
        </div>
      </div>
      <div class='credit-card-debt' v-if="hasCreditCardDebt">
        <page-section-header title-text="חיובי האשראי" color="coral" icon="credit-card-outline"/>
        <div class="credit-card-disclaimer">סה״כ הגיהוצים שעדיין לא ירדו מהעו״ש</div>
        <div class="cards-container">
          <base-balance-page-card v-for="data of cardDebts" :key="data.account"
                                  :amount="data.amount"
                                  :account="`${data.account} ****`"
                                  :source="data.source"
                                  :last-updated="data.lastUpdated"
                                  :credentials-name="data.name"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex';
import PageSectionHeader from '../../../../../base-components/PageSectionHeader.vue';
import Segment from '../../../../../Segment';
import BaseBalancePageCard from './BaseBalancePageCard.vue';

export default {
  name: 'BalancePage',
  components: {
    BaseBalancePageCard,
    PageSectionHeader,
  },
  async created() {
    this.startLoading(this.$options.name);
    await this.init();
    this.doneLoading(this.$options.name);
    Segment.trackUserGot('BalancePageEntered', {});
  },
  computed: {
    ...mapGetters('session', ['householdName']),
    ...mapState('balance', ['balances', 'cardDebts']),
    ...mapGetters('balance', ['hasBalance', 'hasCreditCardDebt']),
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
    ...mapActions('balance', ['init']),
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .balance-page {

    .disclaimer-background {
      background-color: rgba($riseup_gray_0, 0.5);

      .disclaimer-content {
        @include responsive-padding;
        display: flex;
        flex-direction: row;
        padding-top: 10px;
        padding-bottom: 10px;

        .icon {
          margin: 1px 0 0 4px;
        }

        .text {
          line-height: 16px;
          font-family: SimplerPro;
          font-size: 12px;
          color: $riseup_gray_2;

          .bold {
            font-weight: bold;
          }
        }
      }
    }

    .balance-page-content {
      @include responsive-padding;
      margin-top: 14px;

      .credit-card-debt {
        margin-top: 50px;

        .cards-container {
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .credit-card-disclaimer {
          margin-bottom: 20px;
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/balance/BalancePage.vue